import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const AnimatedLine = ({ delay = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });

  return (
    <div ref={ref} className="w-full h-[1px] bg-white/10 overflow-hidden">
      <motion.div
        className="h-full bg-white/30"
        initial={{ width: '0%' }}
        animate={isInView ? { width: '100%' } : { width: '0%' }}
        transition={{ duration: 1.5, delay, ease: 'easeOut' }}
      />
    </div>
  );
};

export default AnimatedLine;
